/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack,
  Button,
  Container,
  Typography,
  Card,
  Box,
  MenuItem,
  Paper,
  Grid,
  Chip,
  alpha,
  useTheme,
  IconButton,
  Avatar,
  Switch,
  Tooltip
} from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditPackages from './EditPackages';
import Iconify from '../../ui-component/iconify';
import AddPackages from './AddPackages';
import { getApi, postApi, patchApi } from '../services/api';
import { toast } from 'react-toastify';
import DeletePackage from './DeletePackage';
import { useNavigate } from 'react-router';
import {
  AdminPanelSettings as AdminIcon,
  CardMembership as PackageIcon,
  AttachMoney as MoneyIcon,
  Schedule as ScheduleIcon,
  TrendingUp as TrendingUpIcon,
  LocalOffer as OfferIcon,
  Business as BusinessIcon,
  Edit as EditActionIcon,
  Delete as DeleteActionIcon,
  Visibility as ViewIcon
} from '@mui/icons-material';

// ----------------------------------------------------------------------

const AdminPackages = () => {
  const theme = useTheme();
  const [openAdd, setOpenAdd] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const navigate = useNavigate();

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const addPackagesData = async (data) => {
    const response = await postApi(`api/packages/add`, data);
    if (response && response.status === 201) {
      getAllPackagesData();
    }
  };

  const getAllPackagesData = async () => {
    try {
      const response = await getApi(`api/packages/getAllPackages`);
      console.log('response for packages ======>', response);
      if (response && response.status === 200) {
        setPackageData(response?.data?.packagesAllData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // edit packages api
  const editPackagesData = async (values) => {
    try {
      const data = values;
      const result = await patchApi(`api/packages/edit/${editData?._id}`, data);
      if (result && result.status === 200) {
        toast.success('Paquete modificado exitosamente');
        getAllPackagesData();
      }
    } catch (error) {
      toast.error('No se pudo modificar el paquete');
    }
  };

  // activar / desactivar plan (los inactivos no se ofrecen a los hoteles)
  const togglePackageActive = async (row) => {
    try {
      const newValue = row.isActive === false; // los docs sin el campo cuentan como activos
      const result = await patchApi(`api/packages/edit/${row._id}`, { isActive: newValue });
      if (result && result.status === 200) {
        toast.success(newValue ? 'Plan activado' : 'Plan desactivado');
        getAllPackagesData();
      }
    } catch (error) {
      toast.error('No se pudo cambiar el estado del plan');
    }
  };

  useEffect(() => {
    getAllPackagesData();
    // eslint-disable-next-line
  }, []);

  // Función para obtener el icono según el nombre del paquete
  const getPackageIcon = (title) => {
    const titleLower = title?.toLowerCase() || '';
    if (titleLower.includes('basic') || titleLower.includes('básico')) {
      return { icon: BusinessIcon, color: theme.palette.info.main };
    } else if (titleLower.includes('pro') || titleLower.includes('premium')) {
      return { icon: OfferIcon, color: theme.palette.warning.main };
    } else if (titleLower.includes('enterprise') || titleLower.includes('empresarial')) {
      return { icon: LocalOffer, color: theme.palette.error.main };
    }
    return { icon: PackageIcon, color: theme.palette.primary.main };
  };

  // Calcular estadísticas
  const totalPackages = packageData?.length || 0;
  const totalRevenue = packageData?.reduce((sum, pkg) => sum + (pkg.amount || 0), 0) || 0;
  const averagePrice = totalPackages > 0 ? totalRevenue / totalPackages : 0;

  const columns = [
    {
      field: '_id',
      headerName: 'N°',
      flex: 0.5,
      cellClassName: 'name-column--cell--capitalize',
      valueGetter: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
      renderCell: (params) => (
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: '0.875rem',
            color: theme.palette.primary.main
          }}
        >
          {params.api.getRowIndexRelativeToVisibleRows(params.row._id) + 1}
        </Box>
      )
    },
    {
      field: 'title',
      headerName: 'Paquete',
      flex: 1.5,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleOpenView = () => {
          navigate(`/dashboard/packages/view/${params.row._id}`);
        };
        const packageIconData = getPackageIcon(params.value);
        const IconComponent = packageIconData.icon;

        return (
          <Box onClick={handleOpenView} sx={{ cursor: 'pointer' }}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: alpha(packageIconData.color, 0.1),
                  color: packageIconData.color
                }}
              >
                <IconComponent sx={{ fontSize: 20 }} />
              </Avatar>
              <Box>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  sx={{
                    '&:hover': {
                      color: theme.palette.primary.main,
                      textDecoration: 'underline'
                    }
                  }}
                >
                  {params.value}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Plan de suscripción
                </Typography>
              </Box>
            </Stack>
          </Box>
        );
      }
    },
    {
      field: 'description',
      headerName: 'Descripción',
      flex: 2,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%'
          }}
        >
          {params.value}
        </Typography>
      )
    },
    {
      field: 'amount',
      headerName: 'Precio',
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MoneyIcon sx={{ fontSize: 16, color: theme.palette.success.main }} />
          <Typography variant="body2" fontWeight={600} color="success.main">
            ${params.value?.toLocaleString()} USD
          </Typography>
        </Stack>
      )
    },
    {
      field: 'days',
      headerName: 'Duración',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <ScheduleIcon sx={{ fontSize: 16, color: theme.palette.info.main }} />
          <Typography variant="body2" fontWeight={500}>
            {params.value} días
          </Typography>
        </Stack>
      )
    },
    {
      field: 'freeDays',
      headerName: 'Días Gratis',
      flex: 0.8,
      renderCell: (params) =>
        Number(params.value) > 0 ? (
          <Chip
            size="small"
            label={`${params.value} días gratis`}
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(theme.palette.success.main, 0.1),
              color: theme.palette.success.main
            }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            —
          </Typography>
        )
    },
    {
      field: 'isActive',
      headerName: 'Estado',
      flex: 1,
      renderCell: (params) => {
        const active = params.row.isActive !== false;
        return (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Tooltip title={active ? 'Desactivar plan (los hoteles no lo verán)' : 'Activar plan'}>
              <Switch size="small" color="success" checked={active} onChange={() => togglePackageActive(params.row)} />
            </Tooltip>
            <Chip
              size="small"
              label={active ? 'Activo' : 'Inactivo'}
              sx={{
                fontWeight: 600,
                backgroundColor: alpha(active ? theme.palette.success.main : theme.palette.grey[500], 0.1),
                color: active ? theme.palette.success.main : theme.palette.text.secondary
              }}
            />
          </Stack>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Acciones',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const handleEditClick = async (data) => {
          setEditData(data);
          handleOpenEdit();
        };

        const handleDeleteClick = async (id) => {
          setDeleteId(id);
          handleOpenDelete();
        };

        const handleViewClick = () => {
          navigate(`/dashboard/packages/view/${params.row._id}`);
        };

        return (
          <Stack direction="row" spacing={1}>
            <IconButton
              size="small"
              onClick={handleViewClick}
              sx={{
                color: theme.palette.info.main,
                '&:hover': { bgcolor: alpha(theme.palette.info.main, 0.1) }
              }}
            >
              <ViewIcon sx={{ fontSize: 18 }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => handleEditClick(params?.row)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.1) }
              }}
            >
              <EditActionIcon sx={{ fontSize: 18 }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => handleDeleteClick(params.row._id)}
              sx={{
                color: theme.palette.error.main,
                '&:hover': { bgcolor: alpha(theme.palette.error.main, 0.1) }
              }}
            >
              <DeleteActionIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Stack>
        );
      }
    }
  ];

  return (
    <>
      <EditPackages open={openEdit} editData={editData} handleClose={handleCloseEdit} editPackagesData={editPackagesData} />
      <AddPackages open={openAdd} handleClose={handleCloseAdd} addPackagesData={addPackagesData} />
      <DeletePackage open={openDelete} handleClose={handleCloseDelete} id={deleteId} getAllPackagesData={getAllPackagesData} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Administración de Paquetes
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Gestiona los planes de suscripción disponibles para los hoteles
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <AdminIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        {/* Statistics Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PackageIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {totalPackages}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Paquetes Disponibles
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <TrendingUpIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    ${totalRevenue.toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Valor Total de Planes
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.info.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <MoneyIcon sx={{ color: theme.palette.info.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="info.main">
                    ${averagePrice.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Precio Promedio
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Controls Section */}
        <Card sx={{ p: 3, mb: 3, borderRadius: 3, border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={2} justifyContent="space-between">
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Gestión de Paquetes de Suscripción
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Crea, edita y administra los planes disponibles para los hoteles
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={handleOpenAdd}
              color="secondary"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1.2,
                boxShadow: theme.shadows[3],
                '&:hover': {
                  boxShadow: theme.shadows[6]
                }
              }}
            >
              Nuevo Paquete
            </Button>
          </Stack>
        </Card>

        {/* Data Table */}
        <TableStyle>
          <Card
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              '& .MuiDataGrid-root': {
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: alpha(theme.palette.secondary.main, 0.05),
                  borderBottom: `2px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
                  '& .MuiDataGrid-columnHeader': {
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }
                },
                '& .MuiDataGrid-row': {
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.02)
                  }
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`
                }
              }
            }}
          >
            <Box sx={{ p: 3, pb: 1 }}>
              <Typography variant="h6" fontWeight={600} color="secondary.main">
                Catálogo de Paquetes ({totalPackages})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Haz clic en un paquete para ver sus detalles completos
              </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={packageData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: {
                      debounceMs: 500,
                      placeholder: 'Buscar paquetes...'
                    }
                  }
                }}
                sx={{
                  '& .MuiDataGrid-toolbarContainer': {
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    p: 2
                  }
                }}
              />
            </Box>
          </Card>
        </TableStyle>
      </Container>
    </>
  );
};

export default AdminPackages;
